import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import NoSSR from 'react-no-ssr';

import PitConLeft from './pitConLeft';
import PitConRight from './pitConRight';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        // console.log('content=', this.props);
        const { content } = this.props;

        return (
            <div className={styles.col_wbf}>
                <div className={styles.space30} />
                <div>
                    <div className={styles.col_w1000}>
                        <div className={styles.space30} />
                        <NoSSR>
                            <Chip
                                id="132837"
                                type="static"
                                title="智库频道-关于我们-智库简介与优势"
                                groupName="国际智库"
                                content={content.staticAboutConLeft}>
                                <PitConLeft />
                            </Chip>
                            <ChipEdit transform={transform} />
                            <Chip
                                id="162620"
                                type="static"
                                title="智库频道-关于我们-理事会"
                                groupName="国际智库"
                                content={content.staticAboutConRight}>
                                <PitConRight />
                            </Chip>
                        </NoSSR>
                    </div>
                </div>
            </div>
        );
    }
}

export default Content;
